/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */
// @flow

import type { Element } from 'react';

import React from 'react';
import { Button } from 'reactstrap';
import { Link } from 'react-router-dom';
import get from 'lodash/fp/get.js';
import { MODEL_NAME } from '@hbrisk/sp3-risk-model-support/models/app/attributes/names/index.js';
import type {
  CellData,
  ColumnType,
} from '#components/pages/Models/Dashboard/ModelsTable/support/types';

type CellType = (data: CellData) => Element<typeof Button>;

const Cell: CellType = data => {
  const uuid = get('original.uuid', data);
  const modelName = get(`original.${MODEL_NAME}`, data) || 'Unnamed Model';
  const archived = get('original.archived', data);
  const modelUuid = get('original.uuid', data);
  return (
    <Button
      id={`modelButton-${modelUuid}`}
      to={`${uuid}`}
      disabled={archived}
      color="link"
      tag={Link}
      title={archived ? 'Model is archived. Restore model to edit' : modelName}
      className="p-0 text-left"
    >
      {modelName}
    </Button>
  );
};

const column: ColumnType = {
  id: MODEL_NAME,
  accessor: MODEL_NAME,
  Header: 'Model',
  Cell,
  additionalClasses: ['text-wrap'],
};

export default column;
